var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "notification-dialog",
          attrs: {
            title: _vm.$t("system.notification_config"),
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.userInfo
            ? _c("div", { staticClass: "user-info-section" }, [
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("system.username")) + ":"),
                  ]),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.userInfo.username)),
                  ]),
                ]),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("system.login_email")) + ":"),
                  ]),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.userInfo.email)),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "notification-container",
            },
            [
              _vm._l(_vm.notifySettingsList, function (item) {
                return [
                  item.notify_type === 1
                    ? _c(
                        "el-card",
                        {
                          key: item.user_notify_config_id,
                          staticClass: "notification-card",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-header",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [
                              _c("div", { staticClass: "card-header-left" }, [
                                _c("div", { staticClass: "card-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "system.trade_daily_report_notification"
                                      )
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "card-desc" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "system.send_trade_daily_notification"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "card-header-right" },
                                [
                                  _c("span", { staticClass: "notify-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("system.email_notification")
                                      ) + ":"
                                    ),
                                  ]),
                                  _c("el-switch", {
                                    attrs: {
                                      "active-value": 1,
                                      "inactive-value": 2,
                                      "active-color": "#13ce66",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeNotifyStatus(
                                          $event,
                                          item
                                        )
                                      },
                                    },
                                    model: {
                                      value: item.email_notify_status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          item,
                                          "email_notify_status",
                                          $$v
                                        )
                                      },
                                      expression: "item.email_notify_status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "left-label" }, [
                                _vm._v(_vm._s(_vm.$t("system.scheduled_send"))),
                              ]),
                              _c("div", { staticClass: "right-control" }),
                            ]),
                            _c(
                              "div",
                              { staticClass: "row action-row" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.sendTestEmail(
                                          item.notify_type
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("system.send_test_email"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  item.notify_type === 2
                    ? _c(
                        "el-card",
                        {
                          key: item.user_notify_config_id,
                          staticClass: "notification-card",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-header",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [
                              _c("div", { staticClass: "card-header-left" }, [
                                _c("div", { staticClass: "card-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "system.balance_alert_notification"
                                      )
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "card-desc" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("system.balance_alert_description")
                                    )
                                  ),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "card-header-right" },
                                [
                                  _c("span", { staticClass: "notify-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("system.email_notification")
                                      ) + ":"
                                    ),
                                  ]),
                                  _c("el-switch", {
                                    attrs: {
                                      "active-value": 1,
                                      "inactive-value": 2,
                                      "active-color": "#13ce66",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeNotifyStatus(
                                          $event,
                                          item
                                        )
                                      },
                                    },
                                    model: {
                                      value: item.email_notify_status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          item,
                                          "email_notify_status",
                                          $$v
                                        )
                                      },
                                      expression: "item.email_notify_status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "left-label" }, [
                                _vm._v(_vm._s(_vm.$t("system.event_trigger"))),
                              ]),
                              _c("div", { staticClass: "right-control" }),
                            ]),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "left-label" }, [
                                _vm._v(_vm._s(_vm.$t("system.alert_amount"))),
                              ]),
                              _c(
                                "div",
                                { staticClass: "right-control amount-control" },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      min: 0,
                                      precision: 0,
                                      max: _vm.MAX_AMOUNT,
                                      "controls-position": "right",
                                      size: "small",
                                    },
                                    model: {
                                      value: _vm.alertAmountInput,
                                      callback: function ($$v) {
                                        _vm.alertAmountInput = $$v
                                      },
                                      expression: "alertAmountInput",
                                    },
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addAlertAmount(item)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("system.add_alert_amount")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        loading: _vm.listLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.submitNotificationConfig(
                                            item
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("components.save")))]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "alert-list" },
                              [
                                !item.trigger_conditions ||
                                item.trigger_conditions.length === 0
                                  ? _c("div", { staticClass: "empty" }, [
                                      _vm._v("—"),
                                    ])
                                  : _vm._e(),
                                _vm._l(
                                  item.trigger_conditions,
                                  function (amt, idx) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: idx,
                                        attrs: { closable: "", size: "small" },
                                        on: {
                                          close: function ($event) {
                                            return _vm.deleteAlertAmount(
                                              item,
                                              idx
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(amt))]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _c(
                              "div",
                              { staticClass: "row action-row" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.sendTestEmail(
                                          item.notify_type
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("system.send_test_email"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }